import { useId, type ReactNode } from 'react';
import { Skeleton } from '../../../components/ui/skeleton';

export const CRM_ICON_BUTTON =
  'flex size-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground';

const CRM_CARD_TITLE_CLASS = 'text-[10px] font-medium tracking-wide text-muted-foreground uppercase';

interface CrmCardProps {
  title: string;
  children: ReactNode;
}

/** One Overview card: Figma's small uppercase title over the card's content, named for screen readers by that title. */
export function CrmCard({ title, children }: CrmCardProps) {
  const titleId = useId();
  return (
    <section aria-labelledby={titleId} className="flex min-w-0 flex-col gap-3 rounded-xl border border-border bg-card p-4">
      <h2 id={titleId} className={CRM_CARD_TITLE_CLASS}>
        {title}
      </h2>
      {children}
    </section>
  );
}

export function CrmCardSkeleton() {
  return <Skeleton className="h-48 w-full" />;
}

/** A card's own failure line, so one failed read never blanks the rest of the Overview. */
export function CrmCardError({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="py-8 text-center text-sm text-rose-600">
      {children}
    </p>
  );
}

export function CrmCardNote({ children }: { children: ReactNode }) {
  return <p className="py-8 text-center text-sm text-muted-foreground">{children}</p>;
}
